
/* styles */
require("!!vue-style-loader!css-loader!../../../node_modules/vue-loader/lib/style-rewriter?id=data-v-d08ed304!postcss-loader!sass-loader!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./HomeTitle.vue")

var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./HomeTitle.vue"),
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler?id=data-v-d08ed304!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./HomeTitle.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/spa/Home/HomeTitle.vue
// module id = 258
// module chunks = 0